import format from 'date-fns/format'
import locales from '../locales'

export function getMonths(language = 'en') {
  const months = []

  for (let i = 0; i < 12; i++) {
    months.push(
      format(new Date(2019, i, 1), 'MMMM', {
        locale: locales[language],
      })
    )
  }

  return months
}
